<template>
  <div class="field">
    <div class="control">
      <textarea class="textarea" :value="value" @input="$emit('input',$event.target.value)" v-if="!fieldProperties.isHTML"></textarea>
      <div v-else>
        <!--div class="box" v-html="value"></div-->
        <medium-editor :text='value' class="textarea isHTML wysiwyg" @edit="debouncedTrigger" :options="options" custom-tag='div'></medium-editor>
      </div>
    </div>
  </div>
</template>

<script>
import { inputProps } from '@/mixins/FormInputMixin'
import editor from 'vue2-medium-editor'
import _ from 'underscore'
export default {
  mixins: [inputProps],
  components: { 'medium-editor': editor },
  name: 'form-textarea',
  data () {
    return {
      content: '',
      options: {
        disableExtraSpaces: true,
        placeholder: {
          /* This example includes the default options for placeholder,
           if nothing is passed this is what it used */
          text: 'Puedes editar este contenido',
          hideOnClick: true
        }
      }
    }
  },
  methods: {
    debouncedTrigger: _.debounce(function (operation) {
      this.$emit('input', operation.api.origElements.innerHTML)
    }, 500)
  }
}
</script>

<style scoped>
@import '~medium-editor/dist/css/medium-editor.css';
@import '~medium-editor/dist/css/themes/beagle.css';

.isHTML {
  overflow-y: scroll;
}
</style>

<style src="wysiwyg.css/wysiwyg.css">
</style>
